import { useState } from "react";
import api from "../services/api";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await api.post("auth/login/", { username, password });
      onLogin(res.data.username, res.data.role);
    } catch (err) {
      const msg = err?.response?.data?.error || "Login failed. Check credentials and try again.";
      setError(msg);
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: "100vh", background: "#0b0f19",
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      padding: "1rem", fontFamily: "'Plus Jakarta Sans', sans-serif"
    }}>

      {/* Card */}
      <div style={{
        width: "100%", maxWidth: 420,
        background: "#0f172a", border: "1px solid #1e293b",
        borderRadius: "1.5rem", overflow: "hidden",
        boxShadow: "0 25px 60px rgba(0,0,0,.5)"
      }}>

        {/* Card header with logo */}
        <div style={{
          background: "#020617", padding: "2rem 2rem 1.5rem",
          borderBottom: "1px solid #1e293b", textAlign: "center"
        }}>
          {/* Logo box — white background */}
          <div style={{
            width: 90, height: 90, background: "#ffffff",
            borderRadius: "1rem", margin: "0 auto 1rem",
            display: "flex", alignItems: "center", justifyContent: "center",
            boxShadow: "0 4px 20px rgba(6,182,212,.2)",
            overflow: "hidden", padding: 4
          }}>
            <img
              src="/logo.svg"
              alt="IHRD PMD Logo"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
              onError={e => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }}
            />
            {/* Fallback if SVG not found */}
            <div style={{
              display: "none", width: "100%", height: "100%",
              alignItems: "center", justifyContent: "center",
              fontFamily: "Orbitron, sans-serif", fontWeight: 700,
              fontSize: "1.1rem", color: "#cc0000"
            }}>IHRD</div>
          </div>

          <h1 style={{
            fontFamily: "Orbitron, sans-serif", fontSize: ".95rem",
            fontWeight: 700, letterSpacing: ".08em",
            background: "linear-gradient(to right,#22d3ee,#60a5fa)",
            WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
            backgroundClip: "text", margin: 0
          }}>IHRD — PMD</h1>
          <p style={{ fontSize: ".7rem", color: "#64748b", marginTop: ".3rem",
            textTransform: "uppercase", letterSpacing: ".15em", fontWeight: 600 }}>
             Agreemented Revenue Management System
          </p>
        </div>

        {/* Form */}
        <div style={{ padding: "1.75rem 2rem 2rem" }}>
          <h2 style={{ fontSize: "1rem", fontWeight: 700, color: "#f1f5f9",
            marginBottom: "1.5rem", textAlign: "center" }}>
            Sign in to your account
          </h2>

          {error && (
            <div style={{
              background: "rgba(239,68,68,.1)", border: "1px solid rgba(239,68,68,.3)",
              color: "#f87171", padding: ".75rem 1rem", borderRadius: ".75rem",
              fontSize: ".8rem", marginBottom: "1rem", display: "flex", alignItems: "center", gap: ".5rem"
            }}>
              <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" style={{flexShrink:0}}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
              </svg>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            {/* Username */}
            <div>
              <label style={{ display: "block", fontSize: ".7rem", fontWeight: 700,
                textTransform: "uppercase", letterSpacing: ".08em", color: "#64748b", marginBottom: ".4rem" }}>
                Username
              </label>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: ".85rem", top: "50%",
                  transform: "translateY(-50%)", color: "#475569" }}>
                  <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                  </svg>
                </span>
                <input
                  type="text" value={username} onChange={e => setUsername(e.target.value)}
                  placeholder="Enter username" required autoComplete="username"
                  style={{
                    width: "100%", background: "#020617", border: "1px solid #1e293b",
                    borderRadius: ".75rem", padding: ".65rem 1rem .65rem 2.5rem",
                    fontSize: ".875rem", color: "#f1f5f9", outline: "none",
                    fontFamily: "'Plus Jakarta Sans', sans-serif", boxSizing: "border-box",
                    transition: "border-color .15s"
                  }}
                  onFocus={e => e.target.style.borderColor = "#06b6d4"}
                  onBlur={e => e.target.style.borderColor = "#1e293b"}
                />
              </div>
            </div>

            {/* Password */}
            <div>
              <label style={{ display: "block", fontSize: ".7rem", fontWeight: 700,
                textTransform: "uppercase", letterSpacing: ".08em", color: "#64748b", marginBottom: ".4rem" }}>
                Password
              </label>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: ".85rem", top: "50%",
                  transform: "translateY(-50%)", color: "#475569" }}>
                  <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                  </svg>
                </span>
                <input
                  type={showPass ? "text" : "password"}
                  value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="Enter password" required autoComplete="current-password"
                  style={{
                    width: "100%", background: "#020617", border: "1px solid #1e293b",
                    borderRadius: ".75rem", padding: ".65rem 2.5rem .65rem 2.5rem",
                    fontSize: ".875rem", color: "#f1f5f9", outline: "none",
                    fontFamily: "'Plus Jakarta Sans', sans-serif", boxSizing: "border-box",
                    transition: "border-color .15s"
                  }}
                  onFocus={e => e.target.style.borderColor = "#06b6d4"}
                  onBlur={e => e.target.style.borderColor = "#1e293b"}
                />
                <button type="button" onClick={() => setShowPass(p => !p)}
                  style={{ position: "absolute", right: ".85rem", top: "50%",
                    transform: "translateY(-50%)", background: "none", border: "none",
                    cursor: "pointer", color: "#475569", padding: 0, display: "flex" }}>
                  {showPass
                    ? <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/></svg>
                    : <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>
                  }
                </button>
              </div>
            </div>

            {/* Submit */}
            <button type="submit" disabled={loading} style={{
              width: "100%", padding: ".75rem",
              background: loading ? "#164e63" : "linear-gradient(135deg,#06b6d4,#3b82f6)",
              border: "none", borderRadius: ".75rem", color: "#fff",
              fontSize: ".9rem", fontWeight: 700, cursor: loading ? "not-allowed" : "pointer",
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              display: "flex", alignItems: "center", justifyContent: "center", gap: ".5rem",
              transition: "opacity .15s", marginTop: ".5rem",
              boxShadow: "0 4px 15px rgba(6,182,212,.25)"
            }}>
              {loading ? (
                <>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                    style={{ animation: "spin 1s linear infinite" }}>
                    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
                  </svg>
                  Authenticating…
                </>
              ) : (
                <>
                  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"/>
                  </svg>
                  Sign In
                </>
              )}
            </button>
          </form>

          {/* Role hint */}
          <div style={{
            marginTop: "1.5rem", padding: ".75rem 1rem",
            background: "rgba(15,23,42,.8)", border: "1px solid #1e293b",
            borderRadius: ".75rem", fontSize: ".7rem", color: "#b6adad"
          }}>
            <div
                style={{
                  fontWeight: 900,
                  fontSize: ".9rem",
                  color: "#dd0808",
                  marginBottom: ".35rem",
                  textTransform: "uppercase",
                  letterSpacing: ".08em",
                  textAlign: "center",
                }}
              >
                SECURITY NOTICE
              </div>

              <div
                style={{
                  color: "#22d3ee",
                  textAlign: "center",
                  fontSize: ".78rem",
                  lineHeight: "1.25",
                  margin: "0 auto",
                  maxWidth: "95%",
                }}
              >
                Access to this application is restricted to authorized personnel only.
                All login activities are monitored and recorded.
              </div>
          </div>
        </div>
      </div>

      {/* Footer note */}
      <p style={{ marginTop: "1.5rem", fontSize: ".65rem", color: "#334155",
        textTransform: "uppercase", letterSpacing: ".1em" }}>
        © 2026 IHRD PMD System Architecture
      </p>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
